import React from 'react';
import {
  View,
  Text,
  StyleSheet,
  SafeAreaView,
  ScrollView,
} from '../utils/webComponents';
import { useTheme } from '../context/ThemeContext';
import { useTranslation } from '../hooks/useTranslation';

const PrivacyPolicyScreen = () => {
  const { theme } = useTheme();
  const { t } = useTranslation();

  return (
    <SafeAreaView style={[styles.container, { backgroundColor: theme.background }]}>
      <ScrollView
        style={styles.scrollView}
        contentContainerStyle={[styles.scrollContent, { alignItems: 'center' }]}
      >
        <View style={styles.content}>
          <Text style={[styles.title, { color: theme.text }]}>
            {t('privacy.title')}
          </Text>
          <Text style={[styles.lastUpdated, { color: theme.textSecondary }]}>
            {t('privacy.lastUpdated')}: {new Date().toLocaleDateString()}
          </Text>

          <View style={styles.section}>
            <Text style={[styles.sectionTitle, { color: theme.text }]}>
              {t('privacy.introduction')}
            </Text>
            <Text p style={[styles.paragraph, { color: theme.textSecondary }]}>
              {t('privacy.introductionText').replace(/\n/g, ' ')}
            </Text>
          </View>

          <View style={styles.section}>
            <Text style={[styles.sectionTitle, { color: theme.text }]}>
              {t('privacy.informationWeCollect')}
            </Text>
            <Text style={[styles.subsectionTitle, { color: theme.text }]}>
              {t('privacy.personalInformation')}
            </Text>
            <Text p style={[styles.paragraph, { color: theme.textSecondary }]}>
              {t('privacy.personalInformationText').replace(/\n/g, ' ')}
            </Text>
            <Text style={[styles.subsectionTitle, { color: theme.text }]}>
              {t('privacy.usageData')}
            </Text>
            <Text p style={[styles.paragraph, { color: theme.textSecondary }]}>
              {t('privacy.usageDataText').replace(/\n/g, ' ')}
            </Text>
          </View>

          <View style={styles.section}>
            <Text style={[styles.sectionTitle, { color: theme.text }]}>
              {t('privacy.howWeUseInformation')}
            </Text>
            <Text p style={[styles.paragraph, { color: theme.textSecondary }]}>
              {t('privacy.howWeUseInformationText').replace(/\n/g, ' ')}
            </Text>
          </View>

          <View style={styles.section}>
            <Text style={[styles.sectionTitle, { color: theme.text }]}>
              {t('privacy.dataRetention')}
            </Text>
            <Text p style={[styles.paragraph, { color: theme.textSecondary }]}>
              {t('privacy.dataRetentionText').replace(/\n/g, ' ')}
            </Text>
          </View>

          <View style={styles.section}>
            <Text style={[styles.sectionTitle, { color: theme.text }]}>
              {t('privacy.childrensPrivacy')}
            </Text>
            <Text p style={[styles.paragraph, { color: theme.textSecondary }]}>
              {t('privacy.childrensPrivacyText').replace(/\n/g, ' ')}
            </Text>
          </View>

          <View style={styles.section}>
            <Text style={[styles.sectionTitle, { color: theme.text }]}>
              {t('privacy.changesToPrivacyPolicy')}
            </Text>
            <Text p style={[styles.paragraph, { color: theme.textSecondary }]}>
              {t('privacy.changesToPrivacyPolicyText').replace(/\n/g, ' ')}
            </Text>
          </View>

          <View style={styles.section}>
            <Text style={[styles.sectionTitle, { color: theme.text }]}>
              {t('privacy.contactInformation')}
            </Text>
            <Text p style={[styles.paragraph, { color: theme.textSecondary }]}>
              {t('privacy.contactInformationText').replace(/\n\n/g, '\n').replace(/\n/g, ' ')}
            </Text>
          </View>
        </View>
      </ScrollView>
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  scrollView: {
    flex: 1,
  },
  scrollContent: {
    paddingBottom: 40,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
  },
  content: {
    maxWidth: 700,
    width: 'calc(100% - 48px)',
    paddingHorizontal: 24,
    paddingTop: 24,
    paddingBottom: 40,
  },
  title: {
    fontSize: 32,
    fontWeight: '700',
    marginBottom: 8,
    textAlign: 'center',
    display: 'block',
  },
  lastUpdated: {
    fontSize: 14,
    marginBottom: 40,
    textAlign: 'center',
    display: 'block',
  },
  section: {
    marginBottom: 32,
  },
  sectionTitle: {
    fontSize: 22,
    fontWeight: '600',
    marginBottom: 12,
    textAlign: 'center',
    display: 'block',
  },
  subsectionTitle: {
    fontSize: 18,
    fontWeight: '600',
    marginTop: 16,
    marginBottom: 8,
    textAlign: 'center',
    display: 'block',
  },
  paragraph: {
    fontSize: 16,
    lineHeight: '1.6',
    textAlign: 'center',
    marginTop: 0,
    marginBottom: 16,
    marginLeft: 0,
    marginRight: 0,
    padding: 0,
  },
});

export default PrivacyPolicyScreen;
